import { csx } from '@vtex/admin-ui'

export const container = csx({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '$space-2 $space-2 $space-2 $space-5',
  opacity: 1,
  height: 'auto',
  maxHeight: '3rem',
  transform: 'translateX(0)',
  transition: 'all 0.6s ease-out',
  boxSizing: 'unset',
  '[data-status="CancellationRequested"]': {
    opacity: '0',
    height: '0',
    padding: '0',
    transform: 'translateX(100px)',
  },

  span: {
    lineHeight: 'normal !important',
  },
})

export const icon = csx({
  height: '36px !important',
  width: '44px',
  transition: 'all 200ms',
  color: '$secondary',
  padding: '$space-2',
  borderRadius: '4px',

  '> span': {
    display: 'inline-block',
  },

  ':hover': {
    backgroundColor: 'var(--admin-ui-bg-action-neutral-tertiaryPressed)',
  },
})

export const quantityPill = csx({
  backgroundColor: 'var(--admin-ui-bg-blue40)',
  borderRadius: '9999px',
  padding: '$space-05 $space-3',

  '> span': {
    color: 'var(--admin-ui-fg-white) !important',
  },
})
